<div class="message-container" [ngClass]="classStyle" *ngIf="message">
    {{message}}
</div>